$(document).on('change', '.bn_theme-switcher', function() {
    let that = $(this),
        active = that.is(':checked');

    $('html').toggleClass('theme-dark');

    $.ajax({
        url: '/site/theme-switcher',
        type: 'POST',
        dataType: 'json',
        data: {active: active}
    });
});